import { useQuery } from '@tanstack/react-query'
import { liveCheckinMonthsTasksService } from '../../services/lives-checkins-months-tasks'

export const MONTH_TASKS_KEY = 'getLiveCheckinsMonthsTasks'

export function useGetMonthTasks(liveCheckinMonthId: number | null | undefined) {
  const enabled = !!liveCheckinMonthId
  const { data, isLoading, refetch } = useQuery({
    queryKey: [MONTH_TASKS_KEY, liveCheckinMonthId],
    enabled,
    queryFn: () =>
      liveCheckinMonthsTasksService.getList({
        take: 500,
        liveCheckinMonthId: liveCheckinMonthId!,
      }),
  })

  return {
    tasks: data?.data ?? [],
    isLoading,
    refetch,
  }
}
